'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keeper = require('../keeper');

var _keeper2 = _interopRequireDefault(_keeper);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _log = require('../log');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QQBrowser = function () {
    function QQBrowser() {
        _classCallCheck(this, QQBrowser);

        this.type = 'qqbrowser';
        this.keeper = undefined;
    }

    _createClass(QQBrowser, [{
        key: 'supportGeo',
        value: function supportGeo() {
            return (/MQQBrowser(?!(.*TBS))/.test(navigator.userAgent)
            ); // x5内核微信、QQ客户端关闭该补位方式，出错率95%+
        }
    }, {
        key: 'process',
        value: function process(succ, fail, next) {
            var _this = this;

            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 预处理
            typeof succ == 'function' || (succ = this.noop);
            typeof fail == 'function' || (fail = this.noop);
            typeof next == 'function' || (next = this.noop);

            if (!this.supportGeo()) return next();
            opt.trigger = function (token) {
                // API超时
                fail({
                    code: 408,
                    message: _this.type + ' API Timeout:' + opt.timeout,
                    type: _this.type
                }, token);
            };
            this.keeper = new _keeper2.default(opt);

            _util2.default.loadScript('//jsapi.qq.com/get?api=app.getGeoLocation', function () {
                try {
                    browser.app.getGeoLocation(function (res) {
                        if (res && res.ret === 'true') {
                            succ({
                                lat: res.latitude,
                                lng: res.longitude,
                                type: _this.type
                            }, _this.keeper.getToken());
                        } else {
                            fail({
                                message: 'qqbrowser geo error',
                                type: _this.type
                            }, _this.keeper.getToken());
                        }
                    }, function () {
                        fail({
                            message: 'qqbrowser geo fail',
                            type: _this.type
                        }, _this.keeper.getToken());
                    });
                } catch (e) {
                    fail({
                        code: 400,
                        message: e && e.message || JSON.stringify(e),
                        type: _this.type
                    }, _this.keeper.getToken());
                }
            });
        }
    }]);

    return QQBrowser;
}();

var instance = new QQBrowser();
module.exports = instance.process.bind(instance);
module.exports.type = instance.type;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/geos/qqbrowser.js
// module id = 400
// module chunks = 0